<template>
  <div>
    <div class="my-profile section-group">
      <div class="row">
        <div class="col-12">
          <div class="col-md-4 col-xs-6 content">
            <div class="col-form-label f-weight" :title="$t('Social.group.groupAddAcc.search_user')">
               {{ $t('Social.group.groupAddAcc.join') }}
            </div>
          </div>
          <div class="sear row">
            <div class="col-md-3">
              <el-input
                v-model="qryParams.displayName"
                :placeholder="$t('Social.group.groupAddAcc.keys')"
              ></el-input>
            </div>
            <div class="col-md-3">
              <el-select v-model="qryParams.type" :placeholder="$t('Social.group.groupAddAcc.placeholder')">
                <el-option :label="$t('Social.group.groupAddAcc.Friendusers')" value="1"> </el-option>
                <el-option :label="$t('Social.group.groupAddAcc.Groupsfriends')" value="2"> </el-option>
              </el-select>
            </div>
            <div class="col-md-2 col-3">
              <button
                type="button"
                class="btn btn-primary"
                :title="$t('Social.group.groupAddAcc.Searchingfriends')"
                @click="handleCurrent(1)"
              >
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
          <!-- /.搜尋位置 -->
          <div class="content pt-4">
            <div class="col form-label f-weight pb-2" :title="$t('Social.group.groupAddAcc.searchresult')">
              {{ $t('Social.group.groupAddAcc.searchresult') }}
            </div>
            <div class="col-12" v-for="(item, ix) in qryResult" :key="ix">
              <label
                for="searched_username"
                class="col-9 ptrl-05 box"
                style=""
                >{{
                  qryType == "1" ? item.displayName : item.sgL_GroupName
                }}</label
              >
              <button
                type="button"
                class="btn btn-primary"
                v-if="qryType == '1' && !item.fireds"
                @click="FriendsCreate(item)"
              >
                <i class="fas fa-user-plus">{{ $t('Social.group.groupAddAcc.Invitation') }}</i>
              </button>
              <button
                type="button"
                class="btn btn-primary"
                :disabled = "item.inGroup"
                v-else-if="qryType == '2'"
                @click="InsertGroup(item)"
              >
                <i class="fas fa-user-plus"> {{ $t('Social.group.groupAddAcc.Join_') }}</i>
              </button>
            </div>
            <div class="row rowTop">
              <div class="col">
                <pagination
                  v-if="qryResult.length > 0"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  :hide-on-single-page="true"
                  :pageSizes="pageParams.pageSizes"
                  @handleCurrentChange="handleCurrent"
                  @handleSizeChange="handleSize"
                />
              </div>
            </div>
          </div>
          <!-- /.搜尋結果 -->
                <!-- 新增 - 申請類別標題 -->
                <div  class="content pt-4">
                  <div  :title="$t('Social.group.groupAddAcc.Friendstatus')" class="col form-label f-weight pb-2 sub-title">{{ $t('Social.group.groupAddAcc.Friendstatus') }}
                  </div>  
                  <div  class="row rowTop">
                    <div  class="col">
                    </div>
                  </div>
                </div>
                <!-- ./新增 - 申請類別標題 -->
          <div class="content pt-4">
            <div class="col form-label f-weight"> {{ $t('Social.group.groupAddAcc.been_invited') }}</div>
            <div
              class="col-12"
              :title="$t('Social.group.groupAddAcc.remove')"
              v-for="(item, ix) in qryResult2"
              :key="ix"
            >
              <label class="col-9 ptrl-05 box">{{
                item.sgL_ToUsersName
              }}</label>
              <button
                type="button"
                class="btn btn-primary"
                data-toggle="modal"
                data-target="#removedfriend"
                :title="$t('Social.group.groupAddAcc.removedfriend')"
                @click="RefuseFriends(item)"
              >
                <i class="fas fa-user-minus"></i>
              </button>
            </div>
            <div class="col-12 rowTop">
              <pagination
                v-if="qryResult2.length > 0"
                :currentPage="pageParams2.currentPage"
                :total="pageParams2.total"
                :limit="pageParams2.limit"
                :small="true"
                :hide-on-single-page="true"
                :pageSizes="pageParams2.pageSizes"
                @handleCurrentChange="handleCurrent2"
                @handleSizeChange="handleSize2"
              />
            </div>
          </div>
          <!-- /.已被我邀請的朋友列表 -->

          <!-- <div class="content pt-4">
            <div class="col form-label f-weight">回覆朋友邀請</div>
            <div class="col-12" v-for="(item, ix) in qryResult3" :key="ix">
              <button
                type="button"
                class="btn btn-primary"
                data-toggle="modal"
                data-target="#acceptfriend"
                :title="接受邀請"
                @click="FriendsCheckInvitationGroupRelation(item, 1)"
              >
                <i class="fas fa-hands-helping"></i>
              </button>
              <button
                type="button"
                class="btn btn-primary"
                data-toggle="modal"
                data-target="#rejectfriend"
                :title="拒絕邀請"
                @click="FriendsCheckInvitationGroupRelation(item, 0)"
              >
                <i class="fas fa-ban"></i>
              </button>
              <div class="friend_invite_fm">
                <p class="user_icon3">
                  <img :src="item.usersLogoBig" />
                </p>
                <label class="ptrl-0">{{ item.sgL_CreateName }}</label>
              </div>
            </div>
          </div> -->
          <!-- /.等待回覆朋友邀請 -->

          <div class="content pt-4">
            <div class="col form-label f-weight"> {{ $t('Social.group.groupAddAcc.Approve') }}</div>
            <div class="col-12 invite_group" v-for="(item, ix) in qryResult4" :key="ix">
              <button
                type="button"
                class="btn btn-primary mr-1"
                data-toggle="modal"
                data-target="#approvefriend"
                :title="$t('Social.group.groupAddAcc.Approve')"
                @click="AcceptFriends(item)"
              >
                <i class="fas fa-sign-in-alt"></i>
              </button>
              <button
                type="button"
                class="btn btn-primary"
                data-toggle="modal"
                data-target="#notapprovefriend"
                :title="$t('Social.group.groupAddAcc.Refuse')"
                @click="ForbiddenFriends(item)"
              >
                <i class="fas fa-ban"></i>
              </button>
              <div class="friend_invite_fm">
                <p class="user_icon4">
                  <img :src="item.usersLogoBig" />
                </p>
                 <!-- <p  class="group_icon">
                        <img  :src="item.userLogoBig">
                      </p>
                      <div  class="group_invite_fm"> 
                        <p  class="group_user_icon">
                          <img  :src="item.userLogoBig">
                        </p>
                      </div> -->
                <label class="ptrl-0">{{ item.sgL_UsersName }}</label>
              </div>
            </div>
            <div class="col-12 rowTop">
              <pagination
                v-if="qryResult4.length > 0"
                :currentPage="pageParams4.currentPage"
                :total="pageParams4.total"
                :limit="pageParams4.limit"
                :small="true"
                :hide-on-single-page="true"
                :pageSizes="pageParams4.pageSizes"
                @handleCurrentChange="handleCurrent4"
                @handleSizeChange="handleSize4"
              />
            </div>
          </div>
          <!-- /.批准成為朋友 -->
                <!-- 新增 - 申請類別標題 -->
                <div  class="content pt-4">
                  <div  :title="$t('Social.group.groupAddAcc.Groupstatus')" class="col form-label f-weight pb-2 sub-title">{{ $t('Social.group.groupAddAcc.Groupstatus') }}
                  </div>  
                  <div  class="row rowTop">
                    <div  class="col">
                    </div>
                  </div>
                </div>
                <!-- ./新增 - 申請類別標題 -->
  <!-- 正在邀請用戶入群 -->
     <div class="content pt-4">
              <div class="col form-label f-weight">{{ $t('Social.group.groupAddAcc.requests_') }}</div>
              <div class="col-12 invite_group" v-for="(item, ix) in qryResult9" :key="ix">
                <button
                  type="button"
                  class="btn btn-primary mr-1"
                  data-toggle="modal"
                  data-target="#acceptgroup"
                  :title="$t('Social.group.groupAddAcc.application')"
                  @click="CheckInvitationGroupRelation(item, 1)"
                >
                  <i class="fas fa-sign-in-alt"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  data-toggle="modal"
                  data-target="#rejectgroup"
                  :title="$t('Social.group.groupAddAcc.rejection')"
                  @click="CheckInvitationGroupRelation(item, 0)"
                >
                  <i class="fas fa-ban"></i>
                </button>
                <!-- <div class="friend_invite_fm"> -->
                  <!-- <p class="user_icon4">
                    <img :src="item.userLogoBig" />
                  </p> -->
                     <p  class="group_icon">
                      <img  :src="item.sgL_Logo">
                    </p>
                    <div  class="group_invite_fm"> 
                      <p  class="group_user_icon">
                        <img  :src="item.userLogoBig">
                      </p>
                    </div>
                  <label class="ptrl-0">{{ item.sgL_UsersName }}</label>
                <!-- </div> -->
              </div>
              <div class="col-12 rowTop">
                <pagination
                  v-if="qryResult9.length > 0"
                  :currentPage="pageParams9.currentPage"
                  :total="pageParams9.total"
                  :limit="pageParams9.limit"
                  :small="true"
                  :hide-on-single-page="true"
                  :pageSizes="pageParams9.pageSizes"
                  @handleCurrentChange="handleCurrent9"
                  @handleSizeChange="handleSize9"
                />
              </div>
            </div>
          <div class="content pt-4">
            <div class="col form-label f-weight">{{ $t('Social.group.groupAddAcc.requests') }}</div>
            <div class="col-12 invite_group" v-for="(item, ix) in qryResult5" :key="ix">
              <button
                type="button"
                class="btn btn-primary mr-1"
                data-toggle="modal"
                data-target="#acceptgroup"
                :title="$t('Social.group.groupAddAcc.application')"
                @click="CheckInvitationGroupRelation(item, 1)"
              >
                <i class="fas fa-sign-in-alt"></i>
              </button>
              <button
                type="button"
                class="btn btn-primary"
                data-toggle="modal"
                data-target="#rejectgroup"
                :title="$t('Social.group.groupAddAcc.rejection')"
                @click="CheckInvitationGroupRelation(item, 0)"
              >
                <i class="fas fa-ban"></i>
              </button>
              <!-- <div class="friend_invite_fm"> -->
                <!-- <p class="user_icon4">
                  <img :src="item.userLogoBig" />
                </p> -->
                 <p  class="group_icon">
                        <img  :src="item.sgL_Logo">
                      </p>
                      <div  class="group_invite_fm"> 
                        <p  class="group_user_icon">
                          <img  :src="item.userLogoBig">
                        </p>
                      </div>
                <label class="ptrl-0">{{ item.sgL_UsersName }}</label>
              <!-- </div> -->
            </div>
            <div class="col-12 rowTop">
              <pagination
                v-if="qryResult5.length > 0"
                :currentPage="pageParams5.currentPage"
                :total="pageParams5.total"
                :limit="pageParams5.limit"
                :small="true"
                :hide-on-single-page="true"
                :pageSizes="pageParams5.pageSizes"
                @handleCurrentChange="handleCurrent"
                @handleSizeChange="handleSize"
              />
            </div>
          </div>
          <!-- /.等待回覆的群組申請入群 -->

          <div class="content pt-4">
            <div class="col form-label f-weight">{{ $t('Social.group.groupAddAcc.admission') }}</div>
            <div class="col-12 invite_group" v-for="(item, ix) in qryResult6" :key="ix">
              <button
                type="button"
                class="btn btn-primary"
                data-toggle="modal"
                data-target="#giveupgroup"
                :title="$t('Social.group.groupAddAcc.Unjoin')"
                @click="forbiddenMyGroupRelation(item)"
              >
                <i class="fas fa-minus"></i>
              </button>
              <!-- <div class="friend_invite_fm"> -->
                <!-- <p class="user_icon4">
                  <img :src="item.sgL_Logo" />
                </p> -->
                 <p  class="group_icon">
                          <img  :src="item.sgL_Logo">
                        </p>
                        <div  class="group_invite_fm"> 
                          <p  class="group_user_icon">
                            <img  :src="item.userLogoBig">
                          </p>
                        </div>
                <label class="ptrl-0">{{ item.sgL_GroupName }}</label>
              <!-- </div> -->
            </div>
            <div class="col-12 rowTop">
              <pagination
                v-if="qryResult6.length > 0"
                :currentPage="pageParams6.currentPage"
                :total="pageParams6.total"
                :limit="pageParams6.limit"
                :small="true"
                :hide-on-single-page="true"
                :pageSizes="pageParams6.pageSizes"
                @handleCurrentChange="handleCurrent"
                @handleSizeChange="handleSize"
              />
            </div>
          </div>
          <!-- /.等待我的申請入群 -->
                <div class="content pt-4">
                <div class="col form-label f-weight">{{ $t('Social.group.groupAddAcc.Applying') }}</div>
                <div class="col-12 invite_group" v-for="(item, ix) in qryResult8" :key="ix">
                  <button
                    type="button"
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#giveupgroup"
                    :title="$t('Social.group.groupAddAcc.Unjoin')"
                    @click="forbiddenMyGroupRelation(item)"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <!-- <div class="friend_invite_fm"> -->
                    <!-- <p class="user_icon4">
                      <img :src="item.sgL_Logo" />
                    </p> -->
                     <p  class="group_icon">
                        <img  :src="item.sgL_Logo">
                      </p>
                      <div  class="group_invite_fm"> 
                        <p  class="group_user_icon">
                          <img  :src="item.userLogoBig">
                        </p>
                      </div>
                    <label class="ptrl-0">{{ item.sgL_GroupName }}</label>
                  <!-- </div> -->
                </div>
                <div class="col-12 rowTop">
                  <pagination
                    v-if="qryResult8.length > 0"
                    :currentPage="pageParams8.currentPage"
                    :total="pageParams8.total"
                    :limit="pageParams8.limit"
                    :small="true"
                    :hide-on-single-page="true"
                    :pageSizes="pageParams8.pageSizes"
                    @handleCurrentChange="handleCurrent8"
                    @handleSizeChange="handleSize8"
                  />
                </div>
              </div>


              <div class="content pt-4">
              <div class="col form-label f-weight">{{ $t('Social.group.groupAddAcc.invitedgroup') }}</div>
              <div class="col-12 invite_group" v-for="(item, ix) in qryResult7" :key="ix">
                <button
                  type="button"
                  class="btn btn-primary mr-1"
                  data-toggle="modal"
                  data-target="#giveupgroup"
                  :title="$t('Social.group.groupAddAcc.Agreepass')"
                  @click="CheckInvitationFriendsRelation(item,1)"
                >
                  <i class="fas fa-sign-in-alt"></i>
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#giveupgroup"
                    :title="$t('Social.group.groupAddAcc.Refusepass')"
                    @click="CheckInvitationFriendsRelation(item,0)"
                  >
                    <i class="fas fa-ban"></i>
                  </button>
                <!-- <div class="friend_invite_fm"> -->
                  <!-- <p class="user_icon4"> -->
                    <!-- <div class="user_icon5" :style="`background: url(${item.sgL_Logo}) no-repeat;background-size: cover;`"><img :src="item.userLogoBig" /></div> -->
                  <!-- </p> -->
                   <p  class="group_icon">
                        <img  :src="item.sgL_Logo">
                      </p>
                      <div  class="group_invite_fm"> 
                        <p  class="group_user_icon">
                          <img  :src="item.userLogoBig">
                        </p>
                      </div>
                  <label class="ptrl-0">{{ item.sgL_GroupName }}</label>
                <!-- </div> -->
              </div>
              <div class="col-12 rowTop">
                <pagination
                  v-if="qryResult7.length > 0"
                  :currentPage="pageParams7.currentPage"
                  :total="pageParams7.total"
                  :limit="pageParams7.limit"
                  :small="true"
                  :hide-on-single-page="true"
                  :pageSizes="pageParams7.pageSizes"
                  @handleCurrentChange="handleCurrent7"
                  @handleSizeChange="handleSize7"
                />
              </div>
            </div>


          <div class="row justify-content-center pt-5"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "@/components/common/Page";
export default {
  components: { pagination },
  data() {
    return {
      dialogText: "",
      qryParams: {
        displayName: "",
        type: "1",
      },
      qryType: "1",
      qryResult: [],
      pageParams: {
        currentPage: 1,
        limit: 5,
        total: 0,
        pageSizes: [5, 10, 15, 20],
      },
      qryResult2: [],
      pageParams2: {
        currentPage: 1,
        limit: 5,
        total: 0,
        pageSizes: [5, 10, 15, 20],
      },
      qryResult3: [],
      pageParams3: {
        currentPage: 1,
        limit: 5,
        total: 0,
        pageSizes: [5, 10, 15, 20],
      },
      qryResult4: [],
      pageParams4: {
        currentPage: 1,
        limit: 5,
        total: 0,
        pageSizes: [5, 10, 15, 20],
      },
      qryResult5: [],
      pageParams5: {
        currentPage: 1,
        limit: 5,
        total: 0,
        pageSizes: [5, 10, 15, 20],
      },
      qryResult9: [],
      pageParams9: {
        currentPage: 1,
        limit: 5,
        total: 0,
        pageSizes: [5, 10, 15, 20],
      },
      qryResult6: [],
      pageParams6: {
        currentPage: 1,
        limit: 5,
        total: 0,
        pageSizes: [5, 10, 15, 20],
      },
      qryResult7: [],
      pageParams7: {
        currentPage: 1,
        limit: 5,
        total: 0,
        pageSizes: [5, 10, 15, 20],
      },
      qryResult8: [],
      pageParams8: {
        currentPage: 1,
        limit: 5,
        total: 0,
        pageSizes: [5, 10, 15, 20],
      },
    };
  },
  created() {
    this.GetMyFriends();
    this.FindGroupRelation();
    this.FindMyGroupRelation();
    this.SendMyToFriends();
    this.FindInvitationGroupRelation();
    this.FindGroupRelationCopy();
    this.FindInvitationGroupRelationing();
    this.InvitingUsersToJoinTheGroup();
  },
  methods: {
    async InvitingUsersToJoinTheGroup () {
      const params = {
        SkipCount: (this.pageParams9.currentPage - 1) * this.pageParams9.limit,
        MaxResultCount: this.pageParams9.limit,
      };
      const { data: res } = await this.$api.social.InvitingUsersToJoinTheGroup(params);
      if (res.success) {
        this.qryResult9 = res.result.items;
        this.pageParams9.total = res.result.totalCount;
      }
    },
    CheckInvitationFriendsRelation(item, Type){
       this.$confirm(`${Type == 1 ? '確定' : '拒絕'}通過入群?`, "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.social
          .FriendsCheckInvitationGroupRelation({
            Id: item.id,
            GroupId: item.sgL_GroupId,
            Type
          })
          .then((res) => {
            if (res.data.success) {
              this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
              this.FindGroupRelationCopy();
            } else {
              this.$message.error({
                type: "error",
                message: res.data.error.message,
              });
            }
          });
      });
    },
    forbiddenMyGroupRelation(item) {
      this.$confirm("放棄入群申請?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.social
          .forbiddenMyGroupRelation({
            Id: item.id,
            GroupId: item.sgL_GroupId,
          })
          .then((res) => {
            if (res.data.success) {
              this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
              this.FindMyGroupRelation();
            } else {
              this.$message.error({
                type: "error",
                message: res.data.error.message,
              });
            }
          });
      });
    },
    FriendsCheckInvitationGroupRelation(item, type) {
      this.$confirm("接受加入群組?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.social
          .FriendsCheckInvitationGroupRelation({
            Id: item.id,
            groupId: item.sgL_GroupId,
            Type: type,
          })
          .then((res) => {
            if (res.data.success) {
              this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
              this.FindGroupRelation();
            } else {
              this.$message.error({
                type: "error",
                message: res.data.error.message,
              });
            }
          });
      });
    },
    CheckInvitationGroupRelation(item, type) {
      this.$confirm("接受朋友邀請?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.social
          .CheckInvitationGroupRelation({
            Id: item.id,
            groupId: item.sgL_GroupId,
            Type: type,
          })
          .then((res) => {
            if (res.data.success) {
              this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
              this.FindGroupRelation();
            } else {
              this.$message.error({
                type: "error",
                message: res.data.error.message,
              });
            }
          });
      });
    },
    RefuseGroup(item) {
      this.$confirm("拒絕朋友邀請?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.social
          .ForbiddenFriends({
            FriendsId: item.id,
          })
          .then((res) => {
            if (res.data.success) {
              this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
              this.GetMyFriends();
            } else {
              this.$message.error({
                type: "error",
                message: res.data.error.message,
              });
            }
          });
      });
    },
    FindInvitationGroupRelation() {
      this.$api.social
        .SendMyToFriends({
          SkipCount:
            (this.pageParams3.currentPage - 1) * this.pageParams3.limit,
          MaxResultCount: this.pageParams3.limit,
        })
        .then((res) => {
          this.qryResult3 = res.data.result.items;
          this.pageParams3.total = res.data.result.totalCount;
        });
    },
    FindGroupRelationCopy () {
      this.$api.social
        .FindInvitationGroupRelation({
          SkipCount:
            (this.pageParams7.currentPage - 1) * this.pageParams7.limit,
          MaxResultCount: this.pageParams7.limit,
        })
        .then((res) => {
          this.qryResult7 = res.data.result.items;
          this.pageParams7.total = res.data.result.totalCount;
        });
    },
    FindInvitationGroupRelationing () {
      this.$api.social
        .FindInvitationGroupRelationing({
          SkipCount:
            (this.pageParams8.currentPage - 1) * this.pageParams8.limit,
          MaxResultCount: this.pageParams8.limit,
        })
        .then((res) => {
          this.qryResult8 = res.data.result.items;
          this.pageParams8.total = res.data.result.totalCount;
        });
    },
    ForbiddenFriends(item) {
      this.$confirm("拒絕朋友邀請?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.social
          .ForbiddenFriends({
            FriendsId: item.id,
          })
          .then((res) => {
            if (res.data.success) {
              this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
              this.GetMyFriends();
            } else {
              this.$message.error({
                type: "error",
                message: res.data.error.message,
              });
            }
          });
      });
    },
    SendMyToFriends() {
      this.$api.social
        .SendMyToFriends({
          SkipCount:
            (this.pageParams2.currentPage - 1) * this.pageParams2.limit,
          MaxResultCount: this.pageParams2.limit,
        })
        .then((res) => {
          this.qryResult2 = res.data.result.items;
          this.pageParams2.total = res.data.result.totalCount;
        });
    },
    InsertGroup(item) {
      this.$api.social
        .InsertGroup({
          groupId: item.sgL_GroupId,
        })
        .then((res) => {
          if (res.data.success) {
            this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
          } else {
            this.$message.error({
              type: "error",
              message: res.data.error.message,
            });
          }
        });
    },
    FindGroupRelation() {
      this.$api.social
        .FindGroupRelation({
          SkipCount:
            (this.pageParams5.currentPage - 1) * this.pageParams5.limit,
          MaxResultCount: this.pageParams5.limit,
        })
        .then((res) => {
          this.qryResult5 = res.data.result.items;
          this.pageParams5.total = res.data.result.totalCount;
        });
    },
    FindMyGroupRelation() {
      this.$api.social
        .FindMyGroupRelation({
          SkipCount:
            (this.pageParams6.currentPage - 1) * this.pageParams6.limit,
          MaxResultCount: this.pageParams6.limit,
        })
        .then((res) => {
          this.qryResult6 = res.data.result.items;
          this.pageParams6.total = res.data.result.totalCount;
        });
    },
    AcceptFriends(item) {
      this.$confirm("批准朋友邀請?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.social
          .AcceptFriends({
            id: item.id,
          })
          .then((res) => {
            if (res.data.success) {
              this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
              this.GetMyFriends();
            } else {
              this.$message.error({
                type: "error",
                message: res.data.error.message,
              });
            }
          });
      });
    },
    RefuseFriends(item) {
      this.$confirm("放棄邀請朋友?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.social
          .RefuseFriends({
            Id: item.id,
          })
          .then((res) => {
            if (res.data.success) {
              this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
              this.GetMyFriends();
              this.SendMyToFriends();
            } else {
              this.$message.error({
                type: "error",
                message: res.data.error.message,
              });
            }
          });
      });
    },
    FriendsCreate(item) {
      this.$api.social
        .FriendsCreate({
          sgL_ToUsersId: item.userId,
        })
        .then((res) => {
          if (res.data.success) {
            this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
            this.SendMyToFriends();
          } else {
            this.$message.error({
              type: "error",
              message: res.data.error.message,
            });
          }
        });
    },
    GetMyFriends() {
      this.$api.social
        .GetMyFriends({
          SkipCount:
            (this.pageParams4.currentPage - 1) * this.pageParams4.limit,
          MaxResultCount: this.pageParams4.limit,
        })
        .then((res) => {
          this.qryResult4 = res.data.result.items;
          this.pageParams4.total = res.data.result.totalCount;
        });
    },
    find() {
      if (this.qryParams.displayName) {
        if (this.qryParams.type == "1") {
          this.$api.social
            .FriendsFindUsers({
              displayName: this.qryParams.displayName,
              SkipCount:
                (this.pageParams.currentPage - 1) * this.pageParams.limit,
              MaxResultCount: this.pageParams.limit,
            })
            .then((res) => {
              this.qryType = "1";
              this.qryResult = res.data.result.items;
              this.pageParams.total = res.data.result.totalCount;
            });
        } else if (this.qryParams.type == "2") {
          this.$api.social
            .GroupFindGroup({
              displayName: this.qryParams.displayName,
              SkipCount:
                (this.pageParams.currentPage - 1) * this.pageParams.limit,
              MaxResultCount: this.pageParams.limit,
            })
            .then((res) => {
              this.qryType = "2";
              this.qryResult = res.data.result.items;
              this.pageParams.total = res.data.result.totalCount;
            });
        }
      } else {
        this.$message.warning("搜尋不能為空或空白");
      }
    },
    handleCurrent(val) {
      this.pageParams.currentPage = val;
      this.find();
    },
    handleSize(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.find();
    },
    handleCurrent9(val) {
      this.pageParams9.currentPage = val;
      this.InvitingUsersToJoinTheGroup();
    },
    handleSize9(val) {
      this.pageParams9.limit = val;
      this.pageParams9.currentPage = 1;
      this.InvitingUsersToJoinTheGroup();
    },
    handleCurrent2(val) {
      this.pageParams2.currentPage = val;
      this.SendMyToFriends();
    },
    handleSize2(val) {
      this.pageParams2.limit = val;
      this.pageParams2.currentPage = 1;
      this.SendMyToFriends();
    },
    handleCurrent7(val) {
      this.pageParams7.currentPage = val;
      this.FindGroupRelationCopy();
    },
    handleSize7(val) {
      this.pageParams7.limit = val;
      this.pageParams7.currentPage = 1;
      this.FindGroupRelationCopy();
    },
    handleCurrent8(val) {
      this.pageParams8.currentPage = val;
      this.FindInvitationGroupRelationing();
    },
    handleSize8(val) {
      this.pageParams8.limit = val;
      this.pageParams8.currentPage = 1;
      this.FindInvitationGroupRelationing();
    },
    handleCurrent3(val) {
      this.pageParams3.currentPage = val;
      this.FindInvitationGroupRelation();
    },
    handleSize3(val) {
      this.pageParams3.limit = val;
      this.pageParams3.currentPage = 1;
      this.FindInvitationGroupRelation();
    },
    handleCurrent4(val) {
      this.pageParams4.currentPage = val;
      this.GetMyFriends();
    },
    handleSize4(val) {
      this.pageParams4.limit = val;
      this.pageParams4.currentPage = 1;
      this.GetMyFriends();
    },
    handleCurrent5(val) {
      this.pageParams5.currentPage = val;
      this.FindGroupRelation();
    },
    handleSize5(val) {
      this.pageParams5.limit = val;
      this.pageParams5.currentPage = 1;
      this.FindGroupRelation();
    },
    handleCurrent6(val) {
      this.pageParams6.currentPage = val;
      this.FindMyGroupRelation();
    },
    handleSize6(val) {
      this.pageParams6.limit = val;
      this.pageParams6.currentPage = 1;
      this.FindMyGroupRelation();
    },
  },
};
</script>

<style scoped>
.rowTop >>> .el-pagination__total {
  color: black !important;
}
.rowTop >>> .el-pagination__jump {
  color: black !important;
}
.p-st{
      margin-top: 12px;
    font-size: 18px;
    font-weight: bold;
    color: #717171;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/group/groupAddAcc.vue